import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MyVirtualScrollStrategy, MyVirtualScrollViewport } from './virtual-scroll';
import { GetHeightDirective } from './get-height.directive';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    MyVirtualScrollViewport,
    GetHeightDirective,
  ],
  exports: [
    MyVirtualScrollViewport,
    GetHeightDirective,
  ]
})
export class QueovalVirtualScrollModule { }
